import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Switch, Stack, } from "@mui/material";
import { Icon } from "@iconify/react";
/**
 * Optional Server Settings / node hardware access when editing a role.
 */
export const EditPermissionFollowUpDialog = ({ open, kind, extendedValue, onClose, onConfirm }) => {
    const [allow, setAllow] = useState(extendedValue);
    useEffect(() => {
        if (open && kind !== null) {
            setAllow(extendedValue);
        }
    }, [open, kind, extendedValue]);
    const isAp = kind === "ap-server";
    const handleDone = () => {
        onConfirm(allow);
        onClose();
    };
    const handleCancel = () => {
        onClose();
    };
    return (React.createElement(Dialog, { open: open && kind !== null, onClose: handleCancel, maxWidth: "sm", fullWidth: true, slotProps: {
            backdrop: { sx: { backgroundColor: "rgba(0,0,0,0.55)" } },
        }, PaperProps: {
            elevation: 8,
            sx: {
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                bgcolor: "background.paper",
                backgroundImage: "none",
            },
        } },
        React.createElement(DialogTitle, { sx: { pb: 1 } },
            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1.5 },
                React.createElement(Box, { sx: {
                        width: 44,
                        height: 44,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "primary.main",
                        color: "primary.contrastText",
                    } },
                    React.createElement(Icon, { icon: isAp ? "solar:server-bold-duotone" : "solar:cpu-bolt-bold-duotone", width: 26 })),
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "h6", fontWeight: 700, color: "text.primary" }, isAp ? "Access point editing" : "Node editing"),
                    React.createElement(Typography, { variant: "body2", sx: { mt: 0.25, color: "text.primary", opacity: 0.85 } }, isAp
                        ? "Optional access to advanced server configuration"
                        : "Optional access to hardware & temperature fields")))),
        React.createElement(DialogContent, { sx: { pt: 0 } },
            React.createElement(Typography, { variant: "body2", color: "text.primary", sx: { mb: 2, lineHeight: 1.65, fontWeight: 500 } }, isAp
                ? "Turn on the switch below only if this role should open the Server Settings tab (host, NTP, firmware, timeouts, etc.). Leave it off for alarm and general settings only."
                : "Turn on the switch below only if this role should edit measurement intervals, communication intervals, and temperature thresholds on supported nodes. Leave it off for a simpler node editor."),
            React.createElement(Box, { sx: {
                    p: 2,
                    borderRadius: 2,
                    bgcolor: (theme) => theme.palette.mode === "dark"
                        ? "rgba(255,255,255,0.08)"
                        : "rgba(0, 0, 0, 0.04)",
                    border: "1px solid",
                    borderColor: "divider",
                } },
                React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", spacing: 2 },
                    React.createElement(Box, { sx: { minWidth: 0 } },
                        React.createElement(Typography, { variant: "subtitle1", fontWeight: 600, color: "text.primary" }, isAp
                            ? "Allow Server Settings"
                            : "Allow hardware & temperature settings"),
                        React.createElement(Typography, { variant: "body2", sx: { mt: 0.5, color: "text.primary", opacity: 0.8 } }, isAp
                            ? "Server Settings tab on Edit Access Point"
                            : "Measurement, communication & temperature on Edit Node")),
                    React.createElement(Switch, { checked: allow, onChange: (_, v) => setAllow(v), color: "primary", inputProps: { "aria-label": isAp ? "Server settings" : "Hardware settings" } })))),
        React.createElement(DialogActions, { sx: { px: 3, pb: 2.5, pt: 0, gap: 1 } },
            React.createElement(Button, { onClick: handleCancel, color: "inherit", variant: "outlined" }, "Cancel"),
            React.createElement(Button, { variant: "contained", onClick: handleDone }, "Save"))));
};
